import { H1} from "../UI/generalLayout/Layout.styled";
import { BodyAnnounce, ICardAnnounceStyled } from "./CardAnnouncements.styled";

interface ICardAnnouncements {
  image: string;
  title: string;
}

const CardAnnouncements = ({ image, title }: ICardAnnouncements) => {
  return (
    <ICardAnnounceStyled img={image}>
      <BodyAnnounce>
        <H1 style={{margin: "0px"}} color="white">{title}</H1>
        <p style={{margin: "0px"}}>Clique para ver mais</p>
      </BodyAnnounce>
    </ICardAnnounceStyled>
  );
};

export default CardAnnouncements;
